import { create } from "zustand";
import { SessionStatus } from "@customTypes/appStream";
import { CookieList } from "@customTypes/cookies";

interface SessionDataStore {
    // TODO [LOWA-30534] This is only for new step based flow
    streamingUrl: string | undefined | null;
    userEndSession: boolean;
    sessionStatus: SessionStatus;
    lastSessionStatusChangedDateTime: number | undefined;
    sessionID: string | undefined;
    copiedTextFromRemote: string | undefined;
    sessionStartTime: number | undefined;
    microphoneEnabledDuration: number;
    microphoneLastEnabledTime: number | undefined;
    floatingToolbarEnabledDuration: number;
    floatingToolbarLastEnabledTime: number | undefined;
    isFileExplorerReady: boolean;
    // TODO [LOWA-30534] This is only for new step based flow
    cookieSyncTarget: CookieList;
    // TODO [LOWA-30534] This is only for new step based flow
    setStreamingUrl: (url?: string | null) => void;
    setUserEndSession: (flag: boolean) => void;
    setSessionStatus: (value: SessionStatus, dateTime?: number) => void;
    setSessionID: (value: string | undefined) => void;
    setCopiedTextFromRemote: (value: string | undefined) => void;
    setSessionStartTime: (timestamp: number | undefined) => void;
    addMicrophoneEnabledDuration: (duration: number) => void;
    setMicrophoneLastEnabledTime: (timestamp: number | undefined) => void;
    resetMicrophoneEnabledDuration: () => void;
    addFloatingToolbarEnabledDuration: (duration: number) => void;
    setFloatingToolbarLastEnabledTime: (timestamp: number | undefined) => void;
    resetFloatingToolbarEnabledDuration: () => void;
    setIsFileExplorerReady: (isReady: boolean) => void;
    // TODO [LOWA-30534] This is only for new step based flow
    setCookieSyncTarget: (cookies: CookieList) => void;
}

/**
 * Store for data from remote session
 */
export const useSessionDataStore = create<SessionDataStore>((set) => ({
    streamingUrl: undefined,
    userEndSession: false,
    sessionStatus: "Unknown",
    lastSessionStatusChangedDateTime: undefined,
    copiedTextFromRemote: undefined,
    sessionID: undefined,
    sessionStartTime: undefined,
    microphoneEnabledDuration: 0,
    microphoneLastEnabledTime: undefined,
    floatingToolbarEnabledDuration: 0,
    floatingToolbarLastEnabledTime: undefined,
    isFileExplorerReady: false,
    cookieSyncTarget: undefined,
    setStreamingUrl: (url) =>
        set((state) => ({
            ...state,
            streamingUrl: url,
        })),
    setUserEndSession: (flag) =>
        set((state) => ({
            ...state,
            userEndSession: flag,
        })),
    setSessionStatus: (value, dateTime) =>
        set((state) => ({
            ...state,
            sessionStatus: value,
            lastSessionStatusChangedDateTime: dateTime ?? Date.now(),
        })),
    setSessionID: (value) =>
        set((state) => ({
            ...state,
            sessionID: value,
        })),
    setCopiedTextFromRemote: (value) =>
        set((state) => ({
            ...state,
            copiedTextFromRemote: value,
        })),
    setSessionStartTime: (timestamp: number) =>
        set((state) => ({
            ...state,
            sessionStartTime: timestamp,
        })),
    addMicrophoneEnabledDuration: (duration: number) =>
        set((state) => ({
            ...state,
            microphoneEnabledDuration:
                state.microphoneEnabledDuration + duration,
        })),
    setMicrophoneLastEnabledTime: (timestamp: number) =>
        set((state) => ({
            ...state,
            microphoneLastEnabledTime: timestamp,
        })),
    resetMicrophoneEnabledDuration: () =>
        set((state) => ({
            ...state,
            microphoneEnabledDuration: 0,
        })),
    addFloatingToolbarEnabledDuration: (duration: number) =>
        set((state) => ({
            ...state,
            floatingToolbarEnabledDuration:
                state.floatingToolbarEnabledDuration + duration,
        })),
    setFloatingToolbarLastEnabledTime: (timestamp: number) =>
        set((state) => ({
            ...state,
            floatingToolbarLastEnabledTime: timestamp,
        })),
    resetFloatingToolbarEnabledDuration: () =>
        set((state) => ({
            ...state,
            floatingToolbarEnabledDuration: 0,
        })),
    setIsFileExplorerReady: (isReady: boolean) =>
        set((state) => ({
            ...state,
            isFileExplorerReady: isReady,
        })),
    setCookieSyncTarget: (target) =>
        set((state) => ({
            ...state,
            cookieSyncTarget: target,
        })),
}));
